import ProjectsPage from "../pages/projects";
import EditorPage from "../pages/editor";
import AccountPage from "../pages/account";
import Index from "../pages/index";

const indexRoutes = [
  { path: "/projects/:from?", name: "Home", component: ProjectsPage },
  { path: "/project/:projectSlug", name: "Editor", component: EditorPage },
  { path: "/account", name: "Account", component: AccountPage },
  { path: "/", name: "Index", component: Index },
];

export default indexRoutes;
